export const catTexts = {
	knowMore: 'Saber més',
	ngoPurpose:
		"La captació de fons per a projectes de l'ONG,mantenir-lo informat sobre l'ONG i l'evolució del projecte per al qual ha donat fons i l'emissió de certificats de desgravació fiscal.",
	termsRights:
		"Té dret a accedir, rectificar i suprimir les	dades, així com altres drets, com s'explica a la informació addicional.",
	termsAdditionalInfo:
		'Podeu consultar la informació addicional i detallada sobre Protecció de Dades a la nostra pàgina <a href="https://www.worldcoo.com/gdpr">web</a> o bé contactar-nos a <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	termsRecipients:
		'No se cediran dades a tercers, excepte els encarregats de tractament fora de la UE, acollits a Privacy Shield.',
	rights: 'Drets',
	unexpectedError: `S'ha produït un error inesperat`,
	authError: `S'ha produït un error de referència`,
	amountError: 'La quantitat de diners no és vàlida',
	cardError: `S'ha produït un error relacionat amb la targeta`,
	referralError: `S'ha produït un error de referència`,
	transactionError: `S'ha produït un error amb la transacció`,
	FundedByEmployees: `Finançada a través dels empleats/des`,
	resetFilters: 'Borrar filtres',
	basicNeeds: 'Necessitats bàsiques',
	humanRights: 'Drets humans',
	education: 'Educació',
	emergency: 'Emergència',
	feeding: 'Alimentació',
	environment: 'Medi ambient',
	habitat: 'Habitat',
	health: 'Salut',
	category: 'Causa',
	clear: 'Netejar',
	active: 'Actiu',
	finished: 'Finalitzat',
	status: 'Estat',
	filters: 'Filtres',
	year: 'Any',
	dedicateToTemplate:
		"Hola! Heu rebut aquest correu perquè {{donorName}} t'ha dedicat una donació de {{amount}} {{currency}} per l'ONG {{ngoName}} en la campanya {{campaignName}}. Aquesta donació te l'ha dedicat a tu amb la intenció de fer de l'món un lloc una mica millor",
	dedicateToTemplateTitle: 'El missatge de la teva dedicatòria.',
	dedicateToWarning:
		'Aquest missatge s’enviarà al destinatari a l’adreça de correu electrònic indicada anteriorment. Confirmo que he sol·licitat permís al destinatari per enviar aquest missatge',
	dedicateToRecipientEmail: 'Email del destinatari.',
	dedicateToRecipientName: "Nom de l'destinatari.",
	dedicateDonationTitle: 'Vull dedicar la meva donació a alguna persona.',
	dedicateDonationMessage: "M'agradaria dedicar la meva donació a algú",
	responsable: 'Responsable',
	purpose: 'Finalitat',
	legitimation: 'Legitimació',
	recipients: 'Destinataris',
	ngoAdditionalInfoTitle: 'Informació addicional',
	acceptNgoTermsLink: 'termes de Protecció de dades de {{ngo}}',
	termsButton: 'He llegit, accepto i entenc',
	id: 'NIF / NIE',
	taxId: 'CIF',
	passport: 'Passaport',
	others: 'Altres',
	campaignAudited: 'Campanya auditada per',
	aCampaignBy: 'Una campanya de ',
	termsAndCons: 'termes de Protecció de Dades de Worldcoo',
	ngoTerms: 'termes de Protecció de Dades de',
	haveReadAndAccept: 'He llegit, entenc i accepto els',
	activities: 'Activitats',
	additionalInfo: 'Informació adicional',
	anyComments: 'Vols fer algun comentari?',
	businessName: 'Raó social',
	campaignObjectives: 'Objectius de la campanya',
	campaignFunded: 'Campanya finançada!',
	campaigns: 'Campanyes',
	cancel: 'Cancel·lar',
	cardBrandNotAccepted: "No s'accepta aquest tipus de targetes.",
	cardRegisteredSuccessfully: "La targeta s'ha registrat amb èxit",
	cardsSupported: 'Targetes suportades:',
	certificateOnlyValidInExpeditionCountry:
		"El certificat de donació només tindrà validesa en el país d'origen on estigui inscrita l'entitat beneficiària dels donatius.",
	certificateNeededData: 'Dades necessàries per obtenir el certificat de donació:',
	change: 'Canviar',
	checkoutSuccess: "La teva donació s'ha realitzat correctament, gràcies per participar.",
	city: 'Ciutat',
	collectedFundsDistribution: 'Els fons recaptats es repartiran equitativament entre els següents projectes:',
	comments: 'Comentaris',
	company: 'Empresa',
	confirm: 'Confirmar',
	contactData: 'Dades de contacte',
	cookiesMessage: "Aquest lloc utilitza cookies. Si hi continua navegant, considerem que n'accepta l'ús.",
	country: 'País',
	creditCard: 'Targeta de crèdit',
	dataReceivedSuccessfully: 'Hem rebut correctament les teves dades.',
	description: 'Descripció',
	directBeneficiaries: 'Beneficiaris directes',
	directBeneficiariesDescription:
		'Aquelles persones que de forma natural han estat beneficiades per les accions desenvolupades a la campanya',
	documentNumber: 'Nº de document',
	documentType: 'Tipus de document',
	donationAmount: 'Import de donació',
	donationAmountError: "L'import de donació no és correcte",
	donationAmountMinimumIs: "L'import mínim és de {{amount}}",
	donationCertificate: 'Certificat de donació',
	donations: 'Donacions',
	donors: 'Donants',
	donated: 'Donats',
	donatedOf: 'Donats de',
	donateMonthly: 'Donar mensualment',
	donationOnBehalf: 'Fer donació en nom de',
	email: 'Correu electrònic',
	door: 'Porta',
	fillFollowingFields: 'Ompli els següents camps',
	finish: 'Finalitzar',
	floor: 'Pis',
	funded: 'Finançat',
	genericCardError: 'Hi ha hagut algun error amb la targeta.',
	goBack: 'Tornar',
	identityDocument: "Document d'identitat",
	indicateDataToIdentify: "Indica'ns aquestes dades perquè puguem identificar-te:",
	indirectBeneficiaries: 'Beneficiaris indirectes',
	indirectBeneficiariesDescription:
		'Aquelles persones identificables, que reben un efecte potencial de les donacions desenvolupades a la campanya',
	inDoubtContactHere: 'Qualsevol dubte que tinguis pots contactar-nos aquí:',
	informYouViaMail: "T'informarem detalladament per correu electrònic.",
	makeDonation: 'Fer donació',
	makeOneTimeDonation: 'Fer una donació puntual',
	makeYourDonation: 'Fes la teva donació',
	manageMyDonations: 'Gestionar les meves donacions',
	manyThanks: 'Moltes gràcies!',
	modifyAmount: "Modificar l'import de donació",
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Hem rebut la teva sol·licitud correctament.</p><p>En uns dies et farem arribar un correu electrònic confirmant que hem realitzat els canvis que ens has demanat.</p><p>Si tens algun dubte pots contactar aqui:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Si ja ets donant, aquí pots modificar o cancel·lar la teva donació:',
	moreInfo: 'Més informació',
	name: 'Nom',
	next: 'Següent',
	otherAmount: 'Una altra quantitat',
	overlayError:
		"<p>S'ha produït un error</p><p>Si us plau, torna a intentar-ho més tard o posa't en contacte amb nosaltres aquí:</p><p><strong>contact@worldcoo.com</strong></p>",
	particular: 'Particular',
	paymentData: 'Dades de pagament',
	paymentType: 'Forma de pagament',
	personalData: 'Dades personals',
	pleaseFillFields: 'Si us plau, ompli les següents dades:',
	postalCode: 'Codi postal',
	province: 'Província',
	raised: 'Recaptats',
	raisedTillNow: 'Recaptat fins ara:',
	recurrentFormError: "Hi ha hagut algun error processant la teva sol·licitud. Torna-ho més tard o contacta'ns aquí:",
	region: 'Regió',
	repeatEmail: 'Repetir correu electrònic',
	repsolEmployeesPortal: "Portal solidari d'empleats",
	seeCampaigns: 'Veure campanyes',
	send: 'Enviar',
	share: 'Compartir',
	sorry: 'Ho sentim!',
	stairNumber: 'Escala',
	step1: 'Pas 1',
	step2: 'Pas 2',
	step3: 'Pas 3',
	step4: 'Pas 4',
	stopMakingDonation: 'Deixar de donar mensualment',
	streetName: 'Nom de la via',
	streetNumber: 'Num.',
	streetType: 'Tipus de via',
	summary: 'Resum',
	surname: 'Cognoms',
	telefonicaUseCorporateMail:
		'* Si ets empleat de Telefónica en actiu fes servir preferiblement el teu correu electrònic corporatiu.',
	thanks: 'Gràcies!',
	typeTheAmount: "Tecleja l'import",
	unavailableLanguageMessage:
		"No disposem del contingut d'aquesta campanya en català. Treballem constantment per proporcionar més contingut en el seu idioma. Gràcies per la seva paciència.",
	updatesAndLinks: 'Actualitzacions i enllaços',
	validationEqualFields: 'Els camps {{label}} i {{fieldName}} no són iguals',
	validationIsRequired: 'El camp {{label}} és obligatori',
	validationValidEmail: 'El camp {{label}} no és un email vàlid',
	viewCampaignInfo: 'Veure informació de la campanya',
	viewInfo: 'Veure informació',
	wantCertificate: 'Vull un certificat de donació',
	wantWorldcooNewsletter: 'Desitjo rebre informació de Worldcoo',
	whatIsNewAmount: "Diga'ns quin és el nou import que vols donar (en {{currency}}):",
	whatYouWantToDo: 'Què vols fer?',
	whoWillBenefit: `Qui se'n beneficiarà?`,
	youCanAlsoDonateOneTime: "També pots fer una donació puntual accedint a qualsevol d'ells.",
	yourDonationWillBeCharged: 'La teva donació es carregarà el dia 15 de cada mes.',
	yourRequestIsProcessing: "La teva sol·licitud s'està processant. Espera uns segons, si us plau.",
	youSureCancelRecurrentDonation: 'Confirmes que vols deixar de fer una donació mensual?',
	ngoTermsTitle: 'Informació bàsica sobre Protecció de Dades',
	termsPurpose:
		"Gestionar la relació negocial en tots els seus àmbits, així com la seva donació i la seva sol·licitud de certificat, i l'enviament de comunicacions comercials per via electrònica.",
	ngoLegitimation: "La base legal per al tractament	de les seves dades és l'obtenció del seu consentiment.",
	ngoRecipients: 'No es cediran dades a	tercers llevat que hi hagi obligació legal.',
	ngoAdditionalInfoEmail:
		'Podeu consultar la informació addicional i detallada sobre Protecció de Dades a la web de cada ONG.',
	amountMustBeGreaterThanZero: "L'import ha de ser superior a 0",
	amountMustBeLowerThan3000: 'L’import ha de ser inferior a 3000',
	metafieldsNoTicket: 'Fila 0. Donació sense entrada',
	metafieldsTickets:
		'Quantes invitacions necessites per al concert? Tingues en compte que per cada 10€ donats aconsegueixes una invitació.',
};
